import hero from "./hero_template";
import { herolink, herosearchHtml, presearchlinksHtml } from "./hero_template";
import { articlesExtend, getDynamicContent, findsite } from "src/scripts/mixin";

export default (content) => {

    let herolinks = [];
    // console.log(content)


    if (content.contentParsed.match("modul")) {

        // console.log(content, content.contentParsed.split(/\[modul\:sidevelger\]/gmi));

        content.contentParsed.split(/\[modul\:sidevelger\]/gmi).forEach(text => {

            let textParsed = text.replace(/<\/?[^>]+(>|$)/g, "").replace("[/modul:sidevelger]", ""); //.replace(/\r?\n|\r/gmi, "");
            let textSplitted = textParsed.split(/\r?\n|\r|\:/gmi);
            let modulesettings = textSplitted.filter(a => a);

            if (modulesettings.length > 0) {

                let categoryId = modulesettings[1];
                let description = modulesettings[3];

                // console.log(categoryId, description)

                const categorycontent = window.catergories.filter(item => {
                    // console.log(item, categoryId, item.categoryId)
                    return item.categoryId === categoryId ? item : false
                })[0];

                // console.log(categorycontent);

                herolinks.push(herolink({
                    cssclass: (categoryId === "e94d7a64-2cc1-459c-8e9a-a912e8691615" ? "timeline" : "libary"),
                    title: categorycontent.previewItem,
                    link: urlify(categorycontent.item),
                    icon: (categoryId === "e94d7a64-2cc1-459c-8e9a-a912e8691615" ? "show_chart" : "search"),
                    description: description
                }))

            }

        });


    }

    herolinks = herolinks.join("");

    let image = false;

    if (content.image) {
        image = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_1520,h_1212,c_fill,f_webp/" + content.image.path;
    }

    return hero({
        image: image,
        title: content.title,
        cssclass: image ? "hero__hasimage" : "",
        intro: content.metaDynamicId['a1452d97-a2ef-42c8-b4e6-de1ee2940ee7'] || content.metaDynamicId['a55f452b-78ae-4ff4-a937-73efb539dc3e'],
        herolinks: herolinks
    });

}

//((\[modul:(.*)\])(.*)(\[\/modul:(.*)\]))
export const heroSearch = (cb) => {


    fetch(window.apiUrl + "/api/PublicContentApi/find/782f3adf-b815-4cbc-be13-7d55c21a0d1d").then(response => response.json()).then(content => {
        // if (image) {

        //     // console.log("done");
        //     img.alt="";
        //     img.src="https://res.cloudinary.com/ssp/image/fetch/g_center,w_"+width+",f_webp,c_fill/"+image.path;

        //     if(callback)
        //     callback();

        // }


        content = articlesExtend(content);

        console.log(content);

        const presearch = content.metaDynamicId["03632bed-5c1f-4112-be36-1c384cda5df8"].split("#");
        
        
        let links = []

        presearch.forEach(item => {

            links.push(presearchlinksHtml(item))

        });

        links = links.join("");

        const heroSearchHtml = herosearchHtml({
            title: content.title,
            intro: content.metaDynamicId["a55f452b-78ae-4ff4-a937-73efb539dc3e"],
            herolinks: links
        })
        
        document.getElementById("herosearch").innerHTML = heroSearchHtml;
        
        

        if (typeof cb === "function")
            cb();


    })


}
